/**
 * Fixed-timestep accumulator. Gameplay always advances in identical steps
 * (deterministic, frame-rate independent); rendering interpolates between the
 * last two simulation states using the returned alpha.
 */
export class FixedStepLoop {
  private accumulator = 0;

  constructor(
    readonly stepSeconds: number,
    private readonly maxFrameSeconds: number,
  ) {}

  /**
   * Advances the simulation by the real frame time.
   * @returns interpolation factor (0..1) between the previous and current step.
   */
  advance(frameSeconds: number, step: (dt: number) => void): number {
    this.accumulator += Math.min(Math.max(frameSeconds, 0), this.maxFrameSeconds);
    while (this.accumulator >= this.stepSeconds) {
      step(this.stepSeconds);
      this.accumulator -= this.stepSeconds;
    }
    return this.accumulator / this.stepSeconds;
  }

  reset(): void {
    this.accumulator = 0;
  }
}
